import { render, staticRenderFns } from "./CargaCLG.vue?vue&type=template&id=1e55acab&scoped=true"
import script from "./CargaCLG.vue?vue&type=script&lang=js"
export * from "./CargaCLG.vue?vue&type=script&lang=js"
import style0 from "./CargaCLG.vue?vue&type=style&index=0&id=1e55acab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55acab",
  null
  
)

export default component.exports